import React, {useEffect} from "react";
import Header from "../Components/Header";
import heroImg from '../Images/services-hero.webp'
import BreadcrumbMain from "../Components/BreadcrumbMain";
import Services from "../Components/Services";
import StatsBox from "../Components/StatsBox";
import ProcessSection from "../Components/Process";
import AwardsSection from "../Components/AwardsSection";
import Cta from "../Components/Cta";
import SchemaMarkup from "../Components/SchemaMarkup";
import breadcrumbSchema from '../Schemas/breadcrumbSchema'

const ServiceBaldivis=()=>{

useEffect(() => {
    document.title =
    "Settlement Services in Baldivis | LDL Settlement Services";
        
    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
    metaDesc.setAttribute(
    "content",
    "Explore all property settlement services LDL offers in Baldivis; residential, private sales, new titles, subdivisions & more. Trusted, local, hassle-free."
    );
}
        
    const canonical = document.querySelector("link[rel='canonical']");
    if (canonical) {
    canonical.setAttribute("href", "https://ldlsettlementservices.com.au/services/baldivis/");
}
        
    const ogTitle = document.querySelector("meta[property='og:title']");
    if (ogTitle) {
    ogTitle.setAttribute(
    "content",
    "Settlement Services in Baldivis | LDL Settlement Services"
    );
}
        
    const ogDesc = document.querySelector("meta[property='og:description']");
    if (ogDesc) {
    ogDesc.setAttribute(
    "content",
    "Explore all property settlement services LDL offers in Baldivis; residential, private sales, new titles, subdivisions & more. Trusted, local, hassle-free."
    );
}
        
    const ogUrl = document.querySelector("meta[property='og:url']");
    if (ogUrl) {
    ogUrl.setAttribute("content", "https://ldlsettlementservices.com.au/services/baldivis/");
}
        
    const ogImage = document.querySelector("meta[property='og:image']");
    if (ogImage) {
    ogImage.setAttribute(
    "content",
    "https://ldlsettlementservices.com.au/Images/service-img.webp"
    );
}
        
    const twitterTitle = document.querySelector("meta[name='twitter:title']");
    if (twitterTitle) {
    twitterTitle.setAttribute(
    "content",
    "Settlement Services in Baldivis | LDL Settlement Services"
    );
}
        
    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
);
    if (twitterDesc) {
    twitterDesc.setAttribute(
    "content",
    "Explore all property settlement services LDL offers in Baldivis; residential, private sales, new titles, subdivisions & more. Trusted, local, hassle-free."
    );
}
        
    const twitterImage = document.querySelector("meta[name='twitter:image']");
    if (twitterImage) {
    twitterImage.setAttribute(
    "content",
    "https://ldlsettlementservices.com.au/Images/service-img.webp"
    );
    }
}, []);

  const breadcrumbs = breadcrumbSchema([
  {
    name: "Home",
    url: "https://ldlsettlementservices.com.au/"
  },
 {
    name: "Services in Baldivis"
  }
]);
    return(
        <>
        <SchemaMarkup schema={breadcrumbs} />

         <Header
        showBreadcrumb={true}
        pageName="Services in Baldivis"
      />

      <BreadcrumbMain
      subTitle="OUR SERVICES"
      title="Property Settlement Services in Baldivis"
      description="Whether you're buying, selling or transferring property, our experienced settlement agents in Baldivis make the settlement process simple, clear and stress-free."
      image={heroImg}
      showIcons={false}
      extraText="We provide professional property settlement and property conveyancing services across Baldivis and Western Australia, managing the details with care, accuracy and efficiency."
    />

     {/**SERVICES GRID */}
    <Services
      isSlider={false}
      basePath="/services/baldivis"
      desc="Professional settlement solutions for residential, commercial & property transactions in Baldivis and across Western Australia. We provide reliable, transparent and client-focused support."
    />

    {/**STATS SECTION */}
    <StatsBox 
        heading="A Proven Track Record in Baldivis Property Settlements"
        desc="For years, we have helped property owners, buyers and sellers navigate the settlement process with confidence. Our experienced property settlement agents focus on accurate documentation, clear communication and efficient settlement management. From residential property purchases and sales to more complex transfers and title matters, we work closely with you and the relevant parties to help ensure everything is ready when settlement day arrives."
    />

        {/**HOW WE MAKE IT EASY FOR YOU SECTION */}
    <ProcessSection 
        desc="We streamline the entire process with clear communication, expert guidance and dedicated local support, handling the legal and administrative requirements from start to finish."
    />

      {/**AWARDS SECTION */}
   <AwardsSection 
    desc="At LDL Settlement Services, our industry credentials and professional standards reflect our commitment to accuracy, compliance and quality service. We follow established property settlement and conveyancing practices while providing clear, dependable support to our clients."
   />

   {/**CTA SECTION */}
    <Cta 
        heading="Ready for a Smooth, Hassle-Free Settlement in Baldivis?"
        desc="Let our experienced settlement team handle the process with clarity, transparency and professional support — ensuring your property transaction is managed smoothly from start to finish."
    />

        </>
    )
}
export default ServiceBaldivis;